import Answering from "./Answering";
import DisplayAnswer from "./DisplayAnswer";

const MultipleChoice = {
  name: "Choix Multiple",
  slug: "multiple_choice",
  Answering,
  DisplayAnswer,
};

export default MultipleChoice;